import request from '@/utils/request'

export function getMonthlyFleetCardUsageMonths(branchId, size, page, find) {
  return request({
    url: `/mydiesel/monthlyfleetcardusagemonths/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find
    }
  })
}

export function downloadLPKFileHash(branchId, hash) {
  return request({
    url: `/oldsystem/downloadHash/lpk/${branchId}/${hash}`,
    method: 'get',
    responseType: 'blob',
    timeout: 300000
  })
}

export function downloadLPKPetrolFileHash(branchId, hash) {
  return request({
    url: `/oldsystem/downloadHash/lpkPetrol/${branchId}/${hash}`,
    method: 'get',
    responseType: 'blob',
    timeout: 300000
  })
}

export function downloadLPKEhailingFileHash(branchId, hash) {
  return request({
    url: `/oldsystem/downloadHash/lpkEhailing/${branchId}/${hash}`,
    method: 'get',
    responseType: 'blob',
    timeout: 300000
  })
}

export function downloadLPK(branchId, dates, usageColumn, type, oilcompanyKey) {
  return request({
    url: `/oldsystem/download/lpk/${branchId}`,
    method: 'get',
    params: {
      monthYear: dates,
      usageColumn: usageColumn,
      type,
      oilcompanyKey
    },
    responseType: 'blob',
    timeout: 300000
  })
}

export function downloadLPKPetrol(branchId, dates, usageColumn, type, oilcompanyKey) {
  return request({
    url: `/oldsystem/download/lpkPetrol/${branchId}`,
    method: 'get',
    params: {
      monthYear: dates,
      usageColumn: usageColumn,
      type,
      oilcompanyKey
    },
    responseType: 'blob',
    timeout: 300000
  })
}

export function downloadLPKEhailing(branchId, dates, usageColumn, type, oilcompanyKey) {
  return request({
    url: `/oldsystem/download/lpkEhailing/${branchId}`,
    method: 'get',
    params: {
      monthYear: dates,
      usageColumn: usageColumn,
      type,
      oilcompanyKey
    },
    responseType: 'blob',
    timeout: 300000
  })
}

export function downloadLPANewPetrol(branchId, dates, usageColumn, type, oilcompanyKey) {
  return request({
    url: `/oldsystem/download/lpanewpetrol/${branchId}`,
    method: 'get',
    params: {
      monthYear: dates,
      usageColumn: usageColumn,
      type,
      oilcompanyKey
    },
    responseType: 'blob',
    timeout: 300000
  })
}

export function downloadLPANewDiesel(branchId, dates, usageColumn, type, oilcompanyKey) {
  return request({
    url: `/oldsystem/download/lpanewdiesel/${branchId}`,
    method: 'get',
    params: {
      monthYear: dates,
      usageColumn: usageColumn,
      type,
      oilcompanyKey
    },
    responseType: 'blob',
    timeout: 300000
  })
}

export function downloadOilcoRecordNewDiesel(branchId) {
  return request({
    url: `/oldsystem/download/oilcorecordnewdiesel/${branchId}`,
    method: 'get',
    responseType: 'blob',
    timeout: 300000
  })
}

export function uploadLPK(branchId, data) {
  return request({
    url: `/oldsystem/upload/lpk/${branchId}`,
    method: 'post',
    headers: { 'content-type': 'multipart/form-data' },
    data
  })
}

export function uploadLPKPetrol(branchId, data) {
  return request({
    url: `/oldsystem/upload/lpkPetrol/${branchId}`,
    method: 'post',
    headers: { 'content-type': 'multipart/form-data' },
    data
  })
}

export function uploadLPKEhailing(branchId, data) {
  return request({
    url: `/oldsystem/upload/lpkEhailing/${branchId}`,
    method: 'post',
    headers: { 'content-type': 'multipart/form-data' },
    data
  })
}

export function getAllLPKUploads(branchId, size, page, find, oilcompanyKey) {
  return request({
    url: `/oldsystem/uploads/all/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find,
      oilcompanyKey
    }
  })
}

export function getAllLPKPetrolUploads(branchId, size, page, find, oilcompanyKey) {
  return request({
    url: `/oldsystem/uploads/all/lpkPetrol/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find,
      oilcompanyKey
    }
  })
}

export function getAllLPKEhailingUploads(branchId, size, page, find, oilcompanyKey, filters) {
  return request({
    url: `/oldsystem/uploads/all/lpkEhailing/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find,
      oilcompanyKey,
      ...(filters ? { monthYear: filters.monthYear, type: filters.type } : {})
    }
  })
}

export function getEhailingAccountReport(branchId, params) {
  return request({
    url: `/oldsystem/ehailingAccountReport/${branchId}`,
    method: 'get',
    params
  })
}

export function downloadEhailingAccountReportFile(branchId, params) {
  return request({
    url: `/oldsystem/ehailingAccountReportFile/${branchId}`,
    method: 'get',
    params,
    responseType: 'blob',
    timeout: 300000
  })
}

export function indexRemoteLPADownload(branchId, incomingmodule) {
  return request({
    url: `/oldsystem/remotelpadownload/index/${branchId}/${incomingmodule}`,
    method: 'get'
  })
}

export function getProfileRemoteLPADownload(branchId, incomingmodule) {
  return request({
    url: `/oldsystem/remotelpadownload/getProfile/${branchId}/${incomingmodule}`,
    method: 'get'
  })
}

export function getMonthlyEhailingPair(branchId, monthYear, type) {
  return request({
    url: `/oldsystem/remotelpadownload/monthlyPair/${branchId}`,
    method: 'get',
    params: { monthYear, type }
  })
}

export function downloadRemoteLPADownload(branchId, incomingmodule, typeFile, oilcompanyKey, half) {
  return request({
    url: `/oldsystem/remotelpadownload/download/${branchId}/${incomingmodule}/${typeFile}`,
    method: 'get',
    responseType: 'blob',
    timeout: 300000,
    params: {
      oilcompanyKey: oilcompanyKey,
      ...(half ? { half } : {})
    }
  })
}

export function uploadRemoteLPADownload(branchId, incomingmodule, oilcompanyKey, typeFile, data) {
  return request({
    url: `/oldsystem/remotelpadownload/upload/${branchId}/${incomingmodule}/${oilcompanyKey}/${typeFile}`,
    method: 'post',
    headers: { 'content-type': 'multipart/form-data' },
    data
  })
}

export function uploadEhailingLPAPair(branchId, oilcompanyKey, typeFile, data) {
  return request({
    url: `/oldsystem/remotelpadownload/uploadPair/${branchId}/${oilcompanyKey}/${typeFile}`,
    method: 'post',
    headers: { 'content-type': 'multipart/form-data' },
    timeout: 300000,
    data
  })
}

export function publishEhailingLPAPairsFromRun(branchId, data) {
  return request({
    url: `/oldsystem/remotelpadownload/publishPairsFromRun/${branchId}`,
    method: 'post',
    timeout: 300000,
    data
  })
}

export function removeRemoteLPADownload(branchId, incomingmodule, oilcompanyKey, typeFile) {
  return request({
    url: `/oldsystem/remotelpadownload/remove/${branchId}/${incomingmodule}/${oilcompanyKey}/${typeFile}`,
    method: 'post'
  })
}

export function updateRemoteLPADownload(branchId, data) {
  return request({
    url: `/oldsystem/remotelpadownload/updateProfile/${branchId}`,
    method: 'post',
    data
  })
}

export function targetVehicleRecallByUser(branchId, data) {
  return request({
    url: `/oldsystem/statistics/targetVehicleRecallByUser/${branchId}`,
    method: 'post',
    data,
    timeout: 120000
  })
}



// WEBPACK FOOTER //
// ./src/api/oldsystem.js